"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTeamApiKeysResponseSchema = exports.ListTeamApiKeysQuerySchema = exports.GetTeamApiKeyResponseSchema = exports.RenewTeamApiKeyResponseSchema = exports.UpdateTeamApiKeyResponseSchema = exports.UpdateTeamApiKeyBodySchema = exports.CreateTeamApiKeyResponseSchema = exports.CreateTeamApiKeyBodySchema = exports.TeamApiKeySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
exports.TeamApiKeySchema = (0, core_1.StrictObject)({
    ...core_1.ModelMetaFields,
    user: common_1.UserSchema,
    // The user needs to know the subject as it's the API Key
    subject: ruby_1.SubjectSchema,
});
exports.CreateTeamApiKeyBodySchema = (0, core_1.StrictObject)({
    name: core_1.NameSchema,
    role: ruby_1.TeamRoleSchema,
});
exports.CreateTeamApiKeyResponseSchema = exports.TeamApiKeySchema;
exports.UpdateTeamApiKeyBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.Optional(core_1.NameSchema),
    role: typebox_1.Type.Optional(ruby_1.TeamRoleSchema),
});
exports.UpdateTeamApiKeyResponseSchema = exports.TeamApiKeySchema;
exports.RenewTeamApiKeyResponseSchema = exports.TeamApiKeySchema;
exports.GetTeamApiKeyResponseSchema = exports.TeamApiKeySchema;
exports.ListTeamApiKeysQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListTeamApiKeysResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.TeamApiKeySchema);
